// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"1006764b","482":"a1339168","778":"54fe14bc"}[chunkId] + ".chunk.js";
};